import { render } from "./Change-Password.vue?vue&type=template&id=75d81b17&scoped=true"
import script from "./Change-Password.vue?vue&type=script&lang=js"
export * from "./Change-Password.vue?vue&type=script&lang=js"

import "./Change-Password.vue?vue&type=style&index=0&id=75d81b17&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75d81b17"]])

export default __exports__